import { render, staticRenderFns } from "./addStrategy.vue?vue&type=template&id=b272207a&"
import script from "./addStrategy.vue?vue&type=script&lang=js&"
export * from "./addStrategy.vue?vue&type=script&lang=js&"
import style0 from "./addStrategy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports